export default 'https://cdn.ckeditor.com/4.12.1/full/ckeditor.js'


// WEBPACK FOOTER //
// ./src/utils/ckeditorScript.js